<template>
  <div class="containerGeralProductionOder">
    <div class="contentHeader">
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      >
        <p class="title">
          NOVO P.P SIMPLES Nº
          {{ productionOrder.numero }}
        </p>

        <div
          v-if="productionOrder.numeroVendaMtq"
          style="
            display: flex;
            align-items: center;
            gap: 0.6rem;
            padding: 8px 12px;
            border: 1px solid rgb(181 215 246);
            border-radius: 5px;
            background-color: #ecf4ff;
          "
        >
          <div
            style="
              width: 8px;
              height: 8px;
              border-radius: 50%;
              background-color: rgb(0 97 255);
            "
          ></div>

          <div
            style="
              border-radius: 50px;
              padding: 0.2rem 0.6rem;
              background-color: rgb(214 235 254);
              font-size: 10px;
              line-height: 1;
              box-shadow: 0 0 0 1px rgb(181, 215, 246);
              color: rgb(0 97 255);
            "
          >
            VINCULADA
          </div>

          <p
            style="
              margin: 0;
              padding-left: 0.3rem;
              border-left: solid 1px #80808080;
              font-size: 10px;
              word-spacing: 0.1rem;
            "
          >
            Venda MT2 <strong>Nº {{ productionOrder.numeroVendaMtq }}</strong>
          </p>
        </div>
      </div>

      <div class="mt-3" style="display: flex; justify-content: space-between">
        <div>
          <Input
            ref="codReferencia"
            label="Nº Referencia"
            :labelFixed="true"
            type="text"
            :dataInput.sync="productionOrder.codReferencia"
          />
        </div>

        <div>
          <InputSelect
            ref="situacao"
            label="Situação"
            valueField="value"
            textField="text"
            :items="allSituations"
            :dataSelect.sync="productionOrder.situacao"
            :enableIconCreate="false"
            dataInput="pendente"
          />
        </div>
      </div>

      <b-row
        class="rowResponsive mt-4"
        style="display: flex; gap: 15px; margin: 0; flex-wrap: wrap"
      >
        <div class="contentInputDate">
          <Input
            ref="dataInicio"
            label="Data Inicio"
            type="date"
            :dataInput.sync="productionOrder.dataInicio"
            :labelFixed="true"
          />
        </div>

        <div class="contentInputDate">
          <Input
            ref="dataFim"
            label="Data Fim"
            :labelFixed="true"
            type="date"
            :dataInput.sync="productionOrder.dataFim"
          />
        </div>

        <div class="contentInputDate">
          <Input
            ref="dataEntrega"
            label="Data Entrega"
            :labelFixed="true"
            type="date"
            :dataInput.sync="productionOrder.dataEntrega"
          />
        </div>

        <div class="contentInputSelect">
          <InputInfinit
            ref="idCliente"
            label="Cliente"
            typeFilter="customer"
            :isEdit="productionOrder.idCliente"
            :dataInput.sync="productionOrder.idCliente"
            :onSearch="listCustomerWithPaginate"
            :openCreateModal="() => openModals('modalCreateCustomer')"
            :findAll="createdNewCustomer"
            outsideFilterType="start"
            @selectItem="handleCustomersFromModal"
          />
        </div>

        <div class="contentInputSelect" style="flex: 1 1 50px">
          <InputSelect
            ref="funcionario"
            label="Funcionário"
            :items="listEmployees"
            valueField="id"
            textField="nomeFuncionario"
            :dataSelect.sync="productionOrder.idFuncionario"
            :openCreateModal="() => openModals('modalCreateEmployee')"
          />
        </div>
      </b-row>
    </div>

    <hr />

    <div class="contentItens">
      <div class="responsiveItems" style="padding-top: 0">
        <div class="containerItens">
          <div class="contentTitleItens">
            <div class="titleItens">
              <p class="title">Informações dos Itens</p>
            </div>
          </div>

          <Tabs
            class="mt-2"
            noPadding
            fontSizeTitle="10px"
            gapTabItem="1rem"
            :tabs="tabs"
            :tabSelected="tabSelected"
            :actionToAlterTab="actionToAlterTab"
          >
            <template v-slot:simpleItem>
              <SimpleItem
                :productionOrder="productionOrder"
                @productionOrderId="productionOrder.id = $event"
                @totalOfItensSimple="
                  handleCalcTotalValues($event, 'simpleItemTotals')
                "
                @discountOfItensSimple="
                  handleCalcDiscountValues($event, 'simpleItemTotals')
                "
                @productionOrderIdAndNumber="
                  handleSaveByProductionOrderItems($event)
                "
                @productionOrderItems="
                  productionOrderForModal.items['simpleItem'] = $event
                "
              />
            </template>

            <template v-slot:squareMeterItem>
              <SquareMeterItem
                :productionOrder="productionOrder"
                @productionOrderId="productionOrder.id = $event"
                @totalOfItensSquare="
                  handleCalcTotalValues($event, 'squareMeterItemTotals')
                "
                @discountOfItensSquare="
                  handleCalcDiscountValues($event, 'squareMeterItemTotals')
                "
                @productionOrderIdAndNumber="
                  handleSaveByProductionOrderItems($event)
                "
                @productionOrderItems="
                  productionOrderForModal.items['squareMeterItem'] = $event
                "
              />
            </template>

            <template v-slot:serviceItem>
              <ServiceItem
                :productionOrder="productionOrder"
                @productionOrderId="productionOrder.id = $event"
                @totalOfItensService="
                  handleCalcTotalValues($event, 'serviceItemTotals')
                "
                @discountOfItensService="
                  handleCalcDiscountValues($event, 'serviceItemTotals')
                "
                @productionOrderIdAndNumber="
                  handleSaveByProductionOrderItems($event)
                "
                @productionOrderItems="
                  productionOrderForModal.items['serviceItem'] = $event
                "
              />
            </template>
          </Tabs>
        </div>
      </div>

      <hr />

      <div class="contentDataTotals">
        <div class="contentTotals">
          <span class="inputTotals">
            <p>Total de Itens (R$)</p>
            <input
              disabled
              type="text"
              :value="maskCurrency(objectTotal.totalItems)"
            />
          </span>

          <span class="inputTotals">
            <p>Desconto (R$)</p>
            <input
              disabled
              type="text"
              :value="maskCurrency(handleDiscountProductionOrder)"
            />
          </span>

          <span class="dashed"></span>

          <span class="inputTotals contentFreteTotals">
            <p>Frete (R$)</p>
            <input
              style="color: #5c5855"
              type="text"
              :value="maskCurrency(productionOrder.frete)"
              @input="handleFreteMonetaryValue($event)"
            />
          </span>

          <span class="inputTotals contentFreteTotals">
            <p>Outros (R$)</p>
            <input
              style="color: #5c5855"
              type="text"
              :value="maskCurrency(productionOrder.outrosValores)"
              @input="handleOtherValuesMonetaryValue($event)"
            />
          </span>

          <span class="inputTotals">
            <p>Total (R$)</p>
            <input
              disabled
              type="text"
              :value="maskCurrency(handleTotalProductionOrder)"
            />
          </span>
        </div>
      </div>

      <hr />

      <div
        style="display: flex; flex-direction: column; padding: 0 15px"
        class="mt-4"
      >
        <div style="display: flex; gap: 3px; align-items: center">
          <p class="obsGeneral">Observações Gerais</p>

          <p class="observacoes">
            (Insira aqui observações que serão importantes para você)
          </p>
        </div>

        <textarea
          class="inputTextArea"
          rows="3"
          max-rows="6"
          v-model="productionOrder.observacoes"
        />
      </div>

      <div
        style="
          width: 100%;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          margin: 30px 0 1.5rem 0;
          padding: 0 45px;
        "
      >
        <button
          class="btnFinish btnConfirm"
          @click="handleDataToSendModalProductionOrder"
        >
          Finalizar
        </button>
      </div>
    </div>

    <ModalCreateCustomer
      @getAllNewCustomer="handleCreatedNewCustomer"
      :idCustomerFromSearch="productionOrder.idCliente"
    />

    <ModalCreateEmployees @getAllNewEmployee="listEmployeesSelectBox" />

    <ModalProductionOrder
      :productionOrder="productionOrder"
      :totals="objectTotal"
      :productionOrderForModal="productionOrderForModal"
      @clearAllProductionOder="clear"
    />
  </div>
</template>

<script>
import { mixinProductionOrder } from "./mixins/ProductionOrder";

export default {
  mixins: [mixinProductionOrder],
};
</script>

<style scoped>
#dadosVendaStyle {
  border: none !important;
}

.containerLineOne,
.containerLineTwo {
  width: 100%;
  display: flex;
  gap: 15px;
  position: relative;
}

.containerInputItem {
  width: 50%;
  position: relative;
  min-width: 320px;
}

.inputItem {
  width: 100%;
  min-width: 320px;
  position: relative;
}

.inputItemQnt {
  flex-shrink: 1;
  max-width: 8%;
}

.inputItemVlUnit,
.inputItemHeight,
.inputItemWidth,
.inputItemLoss,
.inputItemVlTot,
.inputItemDesc {
  width: 33.33%;
}

.inputItemObs {
  width: 50%;
  margin-top: 0.5rem;
}

.itemToggleDesc {
  width: 12% !important;
  position: relative;
}

.input:hover {
  background: #d9d9d9;
  border: 1px solid #262626;
}
.inputTotals input:hover {
  background: #d9d9d9 !important;
  border: 1px solid #262626;
}
.custom-select:hover {
  background: #d9d9d9;
  border: 1px solid #262626;
}
.textarea:hover {
  background: #d9d9d9;
  border: 1px solid #262626;
}
.inputTextArea:hover {
  background: #d9d9d9;
  border: 1px solid #262626;
}

.containerInputObsAndBtn {
  display: flex;
  gap: 15px;
  align-items: center;
}

.containerTableItens {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
  flex-wrap: wrap-reverse;
}

.contentTableItens {
  width: 100%;
  height: 242px;
  border: dashed 1px #c1c1c1;
  border-radius: 5px;
  padding: 0.3rem 0.5rem;
}

.tableItem {
  height: 50px;
  background-color: whitesmoke;
  box-shadow: 0 1px 3px rgb(0 0 0 / 24%);
  border-radius: 5px;
  cursor: pointer;
  margin-bottom: 0.5rem;
  position: relative;
  transition: ease 0.2s;
}

.tableItem:hover {
  background-color: rgb(218, 218, 218);
  transition: ease 0.2s;
}

.tableItem td {
  text-align: start !important;
  padding: 0 0.5rem;
}

.btnFinish {
  border-radius: 5px;
  background-color: #00395d;
  width: 165px;
  height: 30px;
  border: none;
  color: white;
  font-size: 12px;
}

.textEllipsis {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.spinProduct {
  color: white;
  width: 20px;
  height: 20px;
}

.contentNumberItem {
  height: 18px;
  width: 26px;
  padding: 0 0.3rem;
  min-width: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  background-color: gray;
  color: white;
}

.contentHeader {
  padding: 0 15px;
}

.contentInputDate {
  flex: 1 1 auto;
  max-width: 130px;
}

.contentInputSelect {
  flex: 1 1 200px;
  min-width: 200px;
  max-width: calc(50%);
}

.contentRemoveItem {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0 5px 5px 0;
  background-color: brown;
  box-shadow: -1px 0 2px rgb(0 0 0 / 24%);
}

.blockRemove {
  background-color: rgb(144, 85, 85);
  pointer-events: none !important;
  cursor: default !important;
}

.blockReplace {
  background-color: #0fbf4d84 !important;
  pointer-events: none !important;
  cursor: default !important;
}

.blockTable {
  background-color: rgb(218, 218, 218);
  pointer-events: none !important;
  cursor: default !important;
}

.contentCloneAndReplaceItem {
  position: absolute;
  right: 30px;
  top: 0;
  height: 100%;
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.3rem;
}

.contentNotItems {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.contentNotItems p {
  font-size: 16px;
  color: #c1c1c1;
}

.infinite {
  position: relative;
}

.cardDadosVendas {
  padding-bottom: 15px !important;
  border-radius: 5px !important;
  background-color: rgba(255, 255, 255, 0.788) !important;
  box-shadow: inset 0 0 0.5em rgb(255, 255, 255), 0 0 0.5em rgba(5, 5, 5, 0.171);
}

.tamanhoBotaoOpenCard {
  color: black;
  font-size: 16px;
  height: 30px;
  display: flex;
  align-items: center;
  /* color: white; */
}

.cardDadosVendasBorda {
  border-radius: 5px !important;
  margin-top: 25px !important;
  margin-bottom: 20px;
  /* background-color: #6a88bd !important; */
  /* color: white; */
}

.tamanhoCards {
  width: 100%;
  display: flex;
  /* background-color: #6a88bd !important; */
  /* box-shadow: 2px 2px 4px 0px black !important ; */
}

.cardDadosVendas {
  padding: 0px 16px 0px 16px !important;
}

.acoesBtns {
  padding: 40px 0 10px 40px;
  margin: 0;
  width: 100%;
  border: none;
}

.btnsGeral {
  display: flex;
  justify-content: space-around;
}

.containerAllCard {
  margin-top: 10px;
}

.containerCheckBox {
  display: flex;
  height: 32px !important;
  margin-top: 31px;
  align-items: center !important;
  background-color: #e9ecef !important;
  border: solid 1px rgb(216, 215, 215);
  border-radius: 5px;
  padding-left: 15px !important;
}

.chkVendaOrcamento {
  margin-top: 18px;
}

.radio-input input {
  display: none;
}

.radio-input {
  position: absolute;
  right: 0;
  top: -2px;
  display: flex;
  --container_width: 130px;
  align-items: center;
  border-radius: 5px;
  background-color: #fff;
  color: #000000;
  width: var(--container_width);
  overflow: hidden;
  border: 1px solid rgba(53, 52, 52, 0.226);
}

.radio-input label {
  width: 100%;
  padding: 2px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  font-size: 11px;
  margin-bottom: 0px !important;
}

.selection {
  display: none;
  position: absolute;
  height: 100%;
  width: calc(var(--container_width) / 3);
  z-index: 0;
  left: 0;
  top: 0;
  transition: 0.15s ease;
}

.radio-input label:has(input:checked) {
  color: #fff;
}

.radio-input label:has(input:checked) ~ .selection {
  background-color: #3a4750;
  display: inline-block;
}

.radio-input label:nth-child(1):has(input:checked) ~ .selection {
  transform: translateX(calc(var(--container_width) * 0 / 3));
}

.radio-input label:nth-child(2):has(input:checked) ~ .selection {
  transform: translateX(calc(var(--container_width) * 1 / 3));
}

.radio-input label:nth-child(3):has(input:checked) ~ .selection {
  transform: translateX(calc(var(--container_width) * 2 / 3));
}

.containerGeralProductionOder {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin-top: 2rem;
  margin-left: 2rem;
  width: 85%;
}

.iconFormaPagamento {
  display: flex;
  justify-content: space-between;
}

.btnFormaPagamento {
  cursor: pointer;
}

p {
  margin: 0;
}

.btnsProductionOrder {
  border-radius: 5px;
  background-color: #00395d;
  width: 165px;
  height: 30px;
  border: none;
  margin-top: 30px;
  color: white;
  font-size: 12px;
}

.btnAddMoreItems {
  display: flex;
  justify-content: center;
  align-items: center;
}

.custom-checkbox {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  font-size: 11px;
  color: #333;
  transition: color 0.3s;
}

.custom-checkbox input[type="checkbox"] {
  display: none;
}

.custom-checkbox .checkmark {
  width: 14px;
  height: 14px;
  border: 2px solid #333;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 4px;
  transition: background-color 0.3s, border-color 0.3s, transform 0.3s;
  transform-style: preserve-3d;
}

.custom-checkbox .checkmark::before {
  content: "\2713";
  font-size: 12px;
  color: transparent;
  transition: color 0.3s, transform 0.3s;
}

.custom-checkbox input[type="checkbox"]:checked + .checkmark {
  background-color: #000000;
  border-color: #333;
  transform: scale(1.1) rotateZ(360deg) rotateY(360deg);
}

.custom-checkbox input[type="checkbox"]:checked + .checkmark::before {
  color: #f0f0f0;
}

.custom-checkbox:hover {
  color: #666;
}

.custom-checkbox:hover .checkmark {
  border-color: #666;
  background-color: #f0f0f0;
  transform: scale(1.05);
}

.custom-checkbox input[type="checkbox"]:focus + .checkmark {
  box-shadow: 0 0 3px 2px rgba(0, 0, 0, 0.2);
  outline: none;
}

.custom-checkbox .checkmark,
.custom-checkbox input[type="checkbox"]:checked + .checkmark {
  transition: background-color 1.3s, border-color 1.3s, color 1.3s,
    transform 0.3s;
}

.cancelReplaceAll {
  background-color: brown;
  border: solid 1px white;
  color: white;
  font-size: 10.5px !important;
  transition: ease-in all 0.1s;
}

.cancelReplaceAll:hover {
  background-color: rgb(134, 34, 34);
  transition: ease-in all 0.1s;
}

.applyReplaceAll {
  background-color: #0fbf4d;
  border: solid 1px white;
  color: white;
  font-size: 10.5px !important;
  transition: ease-in all 0.1s;
}

.applyReplaceAll:hover {
  background-color: #0ca241;
  transition: ease-in all 0.1s;
}

.isDisabled {
  background-color: #e1e1e1;
}

.btnConfirm {
  background-color: whitesmoke;
  border: solid 1px #0fbf4d;
  color: #0fbf4d;
}

.alertStock {
  font-size: 10px;
  color: #3e66ae;
  padding-left: 10px;
}

.alertStockNegative {
  font-size: 10px;
  color: #ff1d08;
  padding-left: 10px;
}

.inputDesc {
  width: 8.3% !important;
}

.labelInputs p {
  font-weight: 100 !important;
  color: #00395d;
  padding: 0;
}

.iconPlus {
  position: absolute;
  right: 20px;
  top: 0;
}

.switch {
  height: 100%;
  margin: 0;
  font-size: 14px;
  position: relative;
  display: inline-block;
}

.containerItens {
  padding: 0 15px;
}

.contentTitleItens {
  align-items: center !important;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  left: 0;
  top: 0;
  bottom: 0;
  background-color: #d9d9d9;
  color: #ffffff;
  border-radius: 50px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  transition: 0.4s;
  width: 50px !important;
  height: 90%;
  font-size: 8px;
}

.slider:before {
  position: absolute;
  content: "R$";
  font-size: 10px;
  height: 82%;
  width: 44%;
  left: 6%;
  border-radius: 50px;
  background-color: #00aa62;
  color: white;
  display: grid;
  align-content: center;
  justify-content: center;
  transition: 0.4s;
  font-weight: bold;
}

.slider:after {
  content: "";
  position: absolute;
  z-index: -1;
}

.switch input:checked + .slider {
  color: white;
}

.switch input:checked + .slider:before {
  content: "%";
  background-color: #00aa62;
  transform: translateX(100%);
  color: white;
}

.switch input {
  display: none;
}

.contentDataTotals {
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  padding: 0 15px;
}

.contentFreteTotals input {
  background-color: white !important;
  border: solid 1px #d9d9d9;
}

.dashed {
  border-bottom: 1px dashed #b1aaa5;
  width: 100%;
  margin: 10px 0;
}

.inputTotals {
  display: flex;
  align-items: center;
  gap: 30px;
  color: #666360;
}

.inputTotals input {
  border: none;
  outline: none;
  text-align: end;
  padding-right: 5px;
  background-color: #d9d9d9;
  border-radius: 5px;
  height: 30px;

  border: solid 1px #d9d9d9;
}

.contentTotals {
  width: 400px;
  display: flex;
  flex-direction: column;
  text-align: right;
  align-items: flex-end;
  font-size: 14px;
  gap: 5px;
}

.itemsProductionOrder {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-left: 0;
}

.observacoes {
  font-size: 12px;
  color: #d5d3d3;
  font-style: italic;
}

.title {
  font-size: 14px;
  color: #666360;
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

.contentIconRemoveItems {
  position: absolute;
  right: -8px;
  top: -12px;
  color: rgb(255, 51, 51);
}

.tooltipDiscount {
  z-index: 3;
  width: 150px;
  padding: 5px;
  font-size: 12px;
  position: absolute;
  color: black;
  border-radius: 5px;
  top: -25px;
  right: -10px;
}

.tooltipItems {
  display: flex;
  gap: 5px;
  justify-content: center;
  align-items: center;
}

@media screen and (max-width: 886px) {
  .contentTableItens {
    width: 100%;
  }
}

@media screen and (max-width: 1024px) {
  .contentInputDate {
    max-width: none;
  }

  .contentInputSelect {
    min-width: 300px;
  }
}

@media screen and (max-width: 1300px) {
  .responsiveItems {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .inputItemHeight,
  .inputItemWidth,
  .inputItemLoss,
  .inputItemVlUnit,
  .inputItemVlTot,
  .inputItemDesc {
    width: 33.33%;
  }

  .inputItemQnt {
    width: 80px;
  }
}

@media screen and (max-width: 800px) {
  .containerLineOne {
    flex-wrap: wrap;
    margin-bottom: 10px;
  }

  .containerInputItem,
  .inputItem {
    width: 100%;
  }

  .inputItemQnt {
    width: 200px !important;
    max-width: 100px;
  }

  .inputItemVlUnit,
  .inputItemHeight,
  .inputItemWidth,
  .inputItemLoss,
  .inputItemVlTot,
  .inputItemDesc {
    width: 23%;
  }

  .itemToggleDesc {
    width: 12% !important;
    position: relative;
  }
}

@media screen and (max-width: 768px) {
  .tooltipDiscount {
    right: -85px;
    top: -28px;
  }

  .contentTableItens {
    overflow-x: auto;
  }

  .contentInputSelect {
    min-width: 100%;
    width: 100%;
  }
}

@media screen and (max-width: 575px) {
  .receiptAccount {
    margin-top: 1rem !important;
  }

  .containerLineTwo {
    flex-wrap: wrap;
    align-items: center;
  }

  .inputItemVlUnit,
  .inputItemHeight,
  .inputItemWidth {
    flex: 1 0 100px;
  }

  .inputItemLoss,
  .inputItemVlTot,
  .inputItemDesc {
    flex: 1 0 100px;
    margin-top: 5px;
  }

  .itemToggleDesc {
    width: 12% !important;
    position: relative;
  }
}

@media screen and (max-width: 475px) {
  .containerInputItem,
  .inputItem {
    width: 100%;
    min-width: 100% !important;
  }
}

@media screen and (max-width: 400px) {
  .itemsProductionOrder {
    margin: 0 !important;
  }

  .btnAddMoreItems {
    width: 100% !important;
  }

  .inputItemQnt {
    width: 60px;
    max-width: 60px;
  }

  .inputItem {
    width: 100%;
    min-width: 100% !important;
  }

  .inputItemObs {
    width: 100%;
  }
}

.titleItens {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.inputTextArea {
  width: 100%;
  border: none;
  outline: none;
  text-decoration: none;
  background-color: white;
  color: #5c5855;
  border-radius: 5px;
  height: 60px;
  padding-left: 5px;
  border: solid 1px #d9d9d9;
  resize: none;
}

.inputSelectSituation {
  border: solid 1px #d5d3d3;
  padding: 3px;
  border-radius: 0.25rem;
  outline: none;
  color: #5c5855;
  font-size: 12px;
}

.obsGeneral {
  font-size: 14px;
  color: #666360;
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

.selectPlus {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}

.fixedSelect {
  position: absolute;
  margin-bottom: 0px;
  bottom: 20px;
  left: 12px;
  z-index: 2;
  background-color: #ffff;
  font-size: 11px;
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
  pointer-events: none;
  transform: translateY(-50%) scale(0.8);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
  height: 12px;
  padding: 0 0.2em;
}

.custom-select:disabled {
  color: black;
  background-color: #d5d3d3;
}

.custom-select {
  background: none;
  text-transform: capitalize;
}

.borderInput {
  border-radius: 3px;
  height: 28px;
  font-size: 12px;
  padding: 0 10px;
  border: 1px solid #d5d3d3;
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .containerGeralProductionOder {
    margin-left: 0rem;
  }

  .containerItens {
    padding: 0 30px;
  }

  .contentTitleItens {
    padding: 0 !important;
  }

  .responsiveItems {
    padding-top: 30px;
    padding-bottom: 10px;
    margin-top: 0rem !important;
  }
  .contentIconRemoveItems {
    right: 10px;
  }
  .contentItens {
    margin-top: 0rem !important;
  }

  .itemsProductionOrder {
    margin-left: 0px;
    margin-right: 0px;
  }

  .btnsProductionOrder {
    width: 140px;
    margin-top: 15px;
    font-size: 10px;
  }
  .contentTotals {
    font-size: 11px;
  }
  .col-12,
  .col-sm-12,
  .col-md-12,
  .col-lg-12,
  .col-xl-12 {
    padding-right: 0px;
    padding-left: 10px;
  }
  .row {
    display: flex;
    flex-wrap: wrap;
    margin-right: 0px;
    margin-left: 0px;
    align-items: center;
    align-content: center;
    justify-content: flex-start;
  }
  .col-md-6 {
    flex: 0 0 32%;
    max-width: 32%;
  }
  .col-md-5 {
    flex: 0 0 32%;
    max-width: 32%;
  }
}

@media (min-width: 576px) and (max-width: 1200px) {
  .col-sm-6 {
    flex: 0 0 32%;
    max-width: 32%;
  }

  .containerItens {
    padding: 0;
    margin: 0;
  }
}

@media screen and (max-width: 700px) {
  .containerGeralProductionOder {
    margin-left: 0rem;
  }

  .containerTableItens {
    padding-left: 15px;
  }

  .containerItens {
    padding: 0;
    margin: 0 15px 0 0;
  }

  .contentTitleItens {
    margin-left: 0 !important;
    padding-left: 16px !important;
  }

  .tooltipDiscount {
    right: -15px;
    top: -23px;
  }

  .col-1,
  .col-2,
  .col-3,
  .col-4,
  .col-5,
  .col-6,
  .col-7,
  .col-8,
  .col-9,
  .col-10,
  .col-11,
  .col-12,
  .col,
  .col-auto,
  .col-sm-1,
  .col-sm-2,
  .col-sm-3,
  .col-sm-4,
  .col-sm-5,
  .col-sm-6,
  .col-sm-7,
  .col-sm-8,
  .col-sm-9,
  .col-sm-10,
  .col-sm-11,
  .col-sm-12,
  .col-sm,
  .col-sm-auto,
  .col-md-1,
  .col-md-2,
  .col-md-3,
  .col-md-4,
  .col-md-5,
  .col-md-6,
  .col-md-7,
  .col-md-8,
  .col-md-9,
  .col-md-10,
  .col-md-11,
  .col-md-12,
  .col-md,
  .col-md-auto,
  .col-lg-1,
  .col-lg-2,
  .col-lg-3,
  .col-lg-4,
  .col-lg-5,
  .col-lg-6,
  .col-lg-7,
  .col-lg-8,
  .col-lg-9,
  .col-lg-10,
  .col-lg-11,
  .col-lg-12,
  .col-lg,
  .col-lg-auto,
  .col-xl-1,
  .col-xl-2,
  .col-xl-3,
  .col-xl-4,
  .col-xl-5,
  .col-xl-6,
  .col-xl-7,
  .col-xl-8,
  .col-xl-9,
  .col-xl-10,
  .col-xl-11,
  .col-xl-12,
  .col-xl,
  .col-xl-auto {
    position: relative;
    width: 100%;
    padding-right: 0px;
    padding-left: 15px;
  }

  .row {
    gap: 10px;
  }

  .infinite {
    padding-right: 15px;
  }

  .responsiveItems {
    padding-top: 25px;
    padding-bottom: 5px;
    margin-top: 0rem !important;
  }

  .inputTotals {
    gap: 10px;
  }

  .obsGeneral {
    width: 80%;
  }

  .itemsProductionOrder {
    position: relative;
    display: flex;
    align-items: center;
    gap: 10px !important;
    padding-left: 16px;
    margin-right: 16px;
    width: 100%;
  }

  .contentIconRemoveItems {
    right: -20px;
  }
}

@media screen and (max-width: 547px) {
  .tooltipDiscount {
    right: -85px;
    top: -30px;
  }

  .containerInputObsAndBtn {
    margin-top: 5px;
  }
}
</style>
